// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 时间格式化组件
import Moment from 'moment'
import api from './api'
import utils from './utils/utils'
import getOssClient from './utils/ossClient'

import './assets/css/index.less'
import './assets/iconfont/iconfont.css'
import space from './components/space/space.vue'
import modal from './components/modal/modal.vue'
import drawer from './components/drawer/drawer.vue'
import markSign from './components/markSign/markSign.vue'
import storeModal from './components/storeModal/storeModal.vue'

Vue.config.productionTip = false

Vue.use(Element, { size: 'small' })
Vue.component('v-space', space)
Vue.component('v-modal', modal)
Vue.component('v-drawer', drawer)
Vue.component('mark-sign', markSign)
Vue.component('store-modal', storeModal)

Vue.prototype.$moment = Moment
Vue.prototype.$api = api
Vue.prototype.$util = utils
Vue.prototype.$getOssClient = getOssClient

/** 权限指令**/
Vue.directive('has', {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})

// 权限检查方法
Vue.prototype.$_has = function(value) {
  const buttonpermsStr = localStorage.getItem('BUTTON_PERMISSION')
  if (buttonpermsStr === undefined || buttonpermsStr === null) {
    return false
  }
  const buttonperms = JSON.parse(buttonpermsStr)
  const isExist = buttonperms.includes(value)
  return isExist
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js